import { Yup } from "csv-package";

const conditions = {
  cond_prevent: Yup.array().ensure().min(1, "Please select at least 1 option"),
  cond_interim_sort: Yup.string().required("We require this information"),
};

export default conditions;
